export enum Size {
    S = 'Small',
    M = 'Medium',
    L = 'Large',
    XL = 'Extra Large',
    XXL = 'Extra Extra Large',
    STANDARD = 'Standard'
}
